import React from 'react';
import Templates from './Templates';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false
    }
  }
});

export default function SmartFormsPage() {
  return (
    <QueryClientProvider client={queryClient}>
      <Templates />
      <ReactQueryDevtools />
    </QueryClientProvider>
  );
}
